module.exports = __webpack_public_path__ + "img/scorm-courses.4e85581.webp";